import store from "@/store/index";
import filesize from "filesize";
import { MessageBox } from "element-ui";

const FileUtils = {
    isPdf(file) {
        return file.type === "application/pdf";
    },
    getFilenameFromBlobResponse(response) {
        return response.headers["content-disposition"]
            .replace("attachment;", "")
            .replace("filename=", "")
            .trim();
    },
    downloadFileFromBlobResponse(response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
            "download",
            this.getFilenameFromBlobResponse(response)
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },
    /**
     * Check if file exceeds max upload file size.
     *
     * @param {File} file
     * @return {Promise}
     */
    checkFileSize(file) {
        return new Promise((resolve, reject) => {
            if (file.size > this.maxFileSize()) {
                MessageBox.alert(
                    `The file you are trying to upload exceeds our maximum file size of ${filesize(
                        this.maxFileSize()
                    )}.`,
                    "Oops!",
                    {
                        confirmButtonText: "OK",
                        type: "warning",
                        callback: (action) => {
                            reject(new Error("file exceeds limit"));
                        },
                    }
                );
            } else {
                resolve();
            }
        });
    },
    /**
     * Returns the max file upload size in bytes.
     *
     * @returns {number}
     */
    maxFileSize() {
        return store.state.config.medialibrary.max_file_size;
    },
};

export default FileUtils;
